<template>
  <div class="basicSettings">
    <!-- 操作设置 -->
    <div v-if="operateShow">
      <a-button type="primary" @click="saveShow">保存</a-button>
      <a-button @click="setCancel" style="margin-left: 10px">重置</a-button>
    </div>
    <!-- 佣金比例 -->
    <div class="commission_rate basic_content">
      <div class="header_title">佣金比例设置</div>
      <div class="content table_list">
        <table border class="ontable">
          <tr>
            <th>商品类型</th>
            <th>佣金比例</th>
            <th>操作</th>
          </tr>
          <tr v-for="(item,index) in form.userPromotionList " :key="index">
            <td>
              <span v-if="item.commissionSharingLevel==1">一级分佣</span>
              <span v-if="item.commissionSharingLevel==2">二级分佣</span>
              <span v-if="item.commissionSharingLevel==3">三级分佣</span>
              <!-- <span v-if="item.commissionSharingLevel==3">三级分佣</span> -->
            </td>
            <td>
              <div class="rate_list">
                <a-input
                  v-model="item.commissionSharingRatio"
                  :disabled="!operateShow"
                  placeholder="请输入内容"
                  class="input"
                  style="width: 150px"
                  type="number"
                  @click="getNumber()"
                ></a-input>
                <span class="icon">%</span>
              </div>
            </td>

            <td>
              <div class="rate_list del_icon" style="width: 70px;">
               <a-icon type="minus-circle" v-if="form.userPromotionList.length>1 && operateShow" :style="{ fontSize: '20px', color: 'red' }" @click="setDel(index, item.id)"/>
              </div>
            </td>

          </tr>
        </table>

        <div class="addfy" v-if="operateShow">
          <a-button type="primary" :disabled="dataList.length<3?false:true" @click="proportion">新增比列</a-button>
           <!-- <el-button type="primary" @click="proportion">新增比列</el-button> -->
        </div>
      </div>
    </div>

     <div class="commission_rate basic_content rakeBack">
      <div class="header_title" style="margin-right:10px;">是否开启自购返佣</div>
       <a-switch default-checked  :disabled="!operateShow" v-model="form.configKickback" />
      
    </div>


    <!-- 提现规则 -->
    <div class="commission_rate basic_content">
      <div class="header_title">提现规则</div>
      <div class="content">
        <div class="header_title role_list">
          <div>提现手续费，从提现额中扣</div>
          <a-input
            v-model="form.withdrawalHandlingFee"
            placeholder="请输入"
            :disabled="!operateShow"
            class="input role_input"
            style="width: 150px"
            type="number"
          ></a-input>
          <div>%（不填则不收取提现手续费）</div>
        </div>
      </div>
    </div>

    <!-- <div class="commission_rate basic_content">
      <div class="header_title">更多设置</div>
      <div class="content">
        <div class="header_title noticeContent">
          <div>分销协议模板：</div>
          <editor v-model="form.protocolTemplate" :readOnly="!operateShow" />
        </div>
      </div>
    </div> -->

    <a-modal :visible="dialogVisible" title="确定保存？" width="400px" @cancel="cancel" :footer="null">
      <div class="modal_content">
        请确定您的修改，保存后无法再次修改！
      </div>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1
        }"
      >
        <a-button @click="cancel">取消</a-button>
        <a-button type="primary" @click="setSave" class="onleft">确 定</a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { getUserPromotionResult, addUserPromotion } from '@/api/promotion/index'
import Editor from '@/components/Editor/Editor'
export default {
  components: {
    Editor
  },
  data() {
    return {
      dialogVisible:false,

      operateShow:false,
      form: {
        protocolTemplate: null,
        withdrawalHandlingFee: 0.00,
        userPromotionList: [],
        configKickback:false,
      },
      dataList: [
            {
               commissionSharingLevel: 1,
               commissionSharingRatio: 0
            }, {
               commissionSharingLevel: 2,
               commissionSharingRatio: 0
            }
            , {
              commissionSharingLevel: 3,
              commissionSharingRatio: 0
            }
          ]
    }
  },
  created() {
    this.getUserPromotionResult()
  },
  methods: {
    getNumber(){
      console.log(this.form.userPromotionList);
      
    },
    proportion(){
      if(this.dataList.length<3){
        this.dataList.push({
           commissionSharingLevel: this.dataList.length+1,
           commissionSharingRatio: 0
        })
      }
      
    },
    // 删除
    setDel(row){
      if(this.dataList.length>1){
        this.dataList.splice(row,1)
        this.dataList.forEach((res,index)=>{
          res.commissionSharingLevel = index+1
        })
        this.form.userPromotionList = this.dataList

      }
      
    },
    saveShow(){
      let total = this.form.userPromotionList.reduce(
        (sum, item) => sum + (Number(item.commissionSharingRatio) || 0), 
        0
      );
      if(total<=30){
        this.dialogVisible = true
      }else{
        this.$message.error('佣金比例总和不能大于30%')
      }
      
    },
    // 保存
    setSave() {
      if(this.form.withdrawalHandlingFee == ''){
        this.form.withdrawalHandlingFee = 0.00
      }
      addUserPromotion(this.form).then((response) => {
        this.dialogVisible = false
        this.getUserPromotionResult()
      })
    },
    cancel(){
      this.dialogVisible = false
    },
    // 取消
    setCancel() {
      this.form.userPromotionList = this.dataList
      this.form.protocolTemplate = null
      this.form.withdrawalHandlingFee = 0.00
    },
    // "data": {
    //     "protocolTemplate": "",
    //     "withdrawalHandlingFee": null,
    //     "userPromotionList": []
    // },
    getUserPromotionResult() {
      getUserPromotionResult().then((response) => {
        if (response.success) {
          if (response.data.userPromotionList.length === 0) {
              this.form.userPromotionList = this.dataList
              this.operateShow = true
          } else {
            this.operateShow = false
            this.form.userPromotionList = response.data.userPromotionList
            this.dataList = response.data.userPromotionList
            this.form.protocolTemplate = response.data.protocolTemplate
            this.form.withdrawalHandlingFee = response.data.withdrawalHandlingFee
            this.form.configKickback = response.data.configKickback=='false'?false:true
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.basicSettings {
  padding: 20px;
  background: #fff;
}
.operate {
  display: flex;
  align-items: center;
}

.basic_content {
  margin-top: 20px;
}
.header_title {
  font-size: 16px;
  font-weight: 600;
}
.content {
  margin-top: 15px;
}
.table_list {
  width: 40%;
}
.ontable {
  width: 100%;
  border-top: none;

  border-collapse: collapse;
}
table {
  border-color: #cecece !important;
}

th {
  background: #e8e8e8;
  padding: 10px 0px;
  font-weight: 500;
}
th,
td {
  border-color: #cecece !important;
  border: 1px solid #000;
  width: 50%;
  text-align: left;
  padding-left: 10px;
  padding-right: 10px;
}

.rate_list {
  display: flex;
  align-items: center;
  padding: 10px 0px;
}

.icon {
  margin-left: 10px;
}

.role_list {
  margin-bottom: 15px;
  display: flex;
}

.role_input {
  margin: 0px 20px;
}

.noticeContent {
  margin-top: 10px;
  display: flex;
}


.modal_content{
  margin-bottom: 50px;
}

.onleft{
  margin-left: 20px;
}

.addfy{
  margin-top: 20px;

}

.del_icon{
  display: flex;
  align-items: center;
  justify-content: center;
}

.rakeBack{
  display: flex;
  align-items: center;

}
</style>